import { isValidElement } from 'react'
import LoadImage from './LoadImage'

interface Options {
  isSelected: boolean
  isPrevious: boolean
}

export default function RenderItem(item: React.ReactNode, options?: Options) {
  if ((!options?.isPrevious && !options?.isSelected) || !isValidElement(item)) return null

  return (
    <div style={{ display: 'flex', position: 'relative', height: '100%', justifyContent: 'center', alignContent: 'center', overflow: 'hidden' }}>
      <LoadImage media={item.props.media} isSelected={!!options?.isSelected} />
    </div>
  )
}
